import A from "../../assets/pics/a.svg";
import Avela from "../../assets/pics/avela.svg";
import { useDeviceWidth } from "../../hooks/useDeviceWidth";
import Button from "../ui/Button";
import Text from "../ui/Text";
import { AnimatedText } from "../ui/AnimatedText";
import { motion } from "motion/react";

function Main() {
  const deviceWidth = useDeviceWidth();
  const isMobile = deviceWidth <= 640;
  return !isMobile ? (
    <section className="flex flex-col h-[100lvh] w-full px-5 mt-[100px] sm:px-[30px] pt-5 sm:pt-[30px] gap-[-60px] relative">
      <div className="flex flex-col gap-8">
        <Text type="h1" className="leading-[100%]">
          <AnimatedText>
            Создаём сайты, Telegram-приложения и выстраиваем IT-инфраструктуру
          </AnimatedText>
        </Text>
        <motion.div
          initial={{ opacity: 0, y: 4, filter: "blur(1px)" }}
          animate={{ opacity: 1, y: 0, filter: "blur(0px)" }}
          transition={{ delay: 0.5, duration: 0.8, ease: [0.25, 0.4, 0.25, 1] }}
        >
          <Button className="w-fit" href="#form">
            Обсудить проект
          </Button>
        </motion.div>
      </div>
      <div className="absolute -bottom-0 -z-10 left-[50%] transform -translate-x-1/2 ">
        <img className="min-w-[110vw]" src={Avela} alt="avela" />
      </div>
    </section>
  ) : (
    <section className="flex flex-col h-[calc(100svh-100px)] w-full px-5 sm:px-[30px] relative">
      <div className="absolute -z-10  left-1/2 transform -translate-x-[58%] max-w-[100vw] w-full ">
        <img src={A} alt="A picture" className="min-w-[144vw] left-0" />
      </div>
      <p className="text-h1-mobile xs:text-[42px] font-magic absolute top-[15vw] left-1/2 transform -translate-x-1/2">
        avela
      </p>
      <Text type="h1" className="absolute bottom-0 max-w-[calc(100vw-40px)]">
        <AnimatedText>
          Создаём сайты, Telegram-приложения и&nbsp;выстраиваем
          IT-инфраструктуру
        </AnimatedText>
      </Text>
    </section>
  );
}

export default Main;
